/* eslint-env browser */

'use strict'

const debug = require('debug')('wallet-switch-chain')
const noop = Function.prototype

const switchChain = function (chainId, callback = noop) {
  // If not running in a browser, error out.
  if (!window) {
    callback(new Error('Only browser environments are supported'))
    return
  }

  if (!chainId) {
    callback(new Error('chainId parameter must be specified'))
    return
  }

  const { ethereum } = window
  // The only wallet known for supporting EIP-3326 so far is MetaMask.
  // @ts-ignore ts(2339)
  // there are other wallets too!
  if (!ethereum || !ethereum.isMetaMask) {
    callback(new Error('Wallet not supported'))
    return
  }

  ethereum
    .request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId }]
    })
    .then(function () {
      debug('Switched to chainId %s', chainId)
      callback()
    })
    .catch(function (err) {
      debug('Failed: %s', err.message)
      callback(err)
    })
}

module.exports = switchChain
